import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./mixin.styl";
import App from "./App";
import { Provider } from "mobx-react";
import RootStore from "./pages/demo-dashboard/modules/store/rootStore";
import Constants from "constants/index";

import * as serviceWorker from "./serviceWorker";

/// Root Store 생성.
/// (Root Store 생성을 통해, Store 간 연계가 가능)
const root = new RootStore();

ReactDOM.render(
  // 스토어 연결
  <Provider {...root}>
    {/* root 요소에 Application 렌더링 */}
    {/* <App path={Constants.RootPrefix + "/"} /> */}
    <App />
  </Provider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
